/**
 * Promise Cancellable Wrapper
 */

const handler = innerPromise => {
  let cancelled = false;

  const promise = new Promise(async (resolve, reject) => {
    try {
      const result = await innerPromise;
      if (!cancelled) {
        return resolve(result);
      }
    } catch (e) {
      if (!cancelled) {
        return reject(e);
      }
    }

    reject({ _cancelled: true });
  });

  promise._cancel = () => {
    cancelled = true;
  };

  return promise;
};

const CancellablePromise = (promiseFunc, ...params) => {
  return handler(promiseFunc(...params));
};

CancellablePromise.all = promises => {
  return handler(Promise.all(promises));
};

export default CancellablePromise;
